const state = {
  routers: [],
  openeds: "/index",
  currentPath: [],
  historyRouter: [],
};
const mutations = {
  SETUP_OPENEDS(state, val) {
    state.openeds = val;
  },
  SET_CURRENT_PATH(state, val) {
    state.currentPath = val;
  },
  SET_HISTORY_ROUTER(state, val) {
    state.historyRouter = val;
  },
};
const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
